import {takeLatest, put, all} from 'redux-saga/effects';
import * as fromApi from '../../../lib/api/musiconline.api';

function* watchGetAnnoncescats(action) {
	try {
		const result = yield fromApi.annoncescatGets(action.token).then((data) => {
			return data;
		});
		yield put({type: 'GET_PACATS_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchPutAnnoncecat(action) {
	try {
		const result = yield fromApi.annoncescatPut(action.payload, action.token, action.data).then((data) => {
			return data;
		});
		yield put({type: 'PUT_PACAT_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchPostAnnoncecat(action) {
	try {
		const result = yield fromApi.annoncescatPost(action.token, action.data).then((data) => {
			return data;
		});
		yield put({type: 'POST_PACAT_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchDelAnnoncecat(action) {
	try {
		const result = yield fromApi.annoncescatDel(action.payload, action.token).then((data) => {
			return data;
		});
		yield put({type: 'DEL_PACAT_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}

function* annoncescat() {
	yield takeLatest('GET_PACATS_SAGAS', watchGetAnnoncescats);
	yield takeLatest('PUT_PACAT_SAGAS', watchPutAnnoncecat);
	yield takeLatest('POST_PACAT_SAGAS', watchPostAnnoncecat);
	yield takeLatest('DEL_PACAT_SAGAS', watchDelAnnoncecat);
}

export default function* rootSaga() {
	yield all([annoncescat()]);
}
